// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__KP3KY","content":"Layout_content__gc_2a","footer":"Layout_footer__wvh06","containerShort":"Layout_containerShort__ZRYcc"};